import useAppContext from "@hooks/useAppContext";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

interface IInputTextarea {
  name: "description";
  label: string;
  inputMode?:
    | "search"
    | "text"
    | "email"
    | "tel"
    | "url"
    | "none"
    | "numeric"
    | "decimal";
  hasAsterisk?: boolean;
  maxLength: number;
  sanitize: (value: string) => string;
  isOnStickyRaQ?: boolean;
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
  isContactForm?: boolean;
}

const InputTextarea = ({
  name,
  label,
  inputMode,
  hasAsterisk,
  maxLength,
  sanitize,
  isOnStickyRaQ,
  scrollContainerRef,
  isContactForm = false,
}: IInputTextarea): JSX.Element => {
  const [hasSmallLabel, setHasSmallLabel] = useState(false);
  const { isMobile } = useAppContext();
  const formContext = useFormContext();
  useEffect(() => {
    // Sets small label on step 2 back button;
    if (formContext.getValues(name)) {
      setHasSmallLabel(true);
    }
  }, []);

  const error = formContext.formState.errors[name];
  return (
    <div
      className={`float-input-container ${isContactForm ? "contact-us" : ""}`}
    >
      <textarea
        id={name}
        maxLength={maxLength}
        aria-label={label}
        className={`${isOnStickyRaQ ? "autofill-bg-white !bg-white" : ""} ${
          error ? "error-field" : ""
        } focus:outline-none`}
        inputMode={inputMode ?? undefined}
        {...formContext.register(name)}
        onChange={(event) => {
          if (error) {
            formContext.clearErrors(name);
          }
          const { value } = event.target;
          event.target.value = sanitize(value);
          setHasSmallLabel(event.target.value.length > 0);
        }}
        onFocus={
          isMobile
            ? (e) => {
                scrollContainerRef?.current?.scrollTo({
                  top:
                    (e.target?.parentElement?.offsetTop ?? 0) -
                    scrollContainerRef?.current?.offsetTop -
                    25,
                  behavior: "smooth",
                });
              }
            : undefined
        }
      />

      <label
        htmlFor={name}
        className={`
        ${hasSmallLabel ? "active-float-label" : ""} `}
      >
        {label}
        {hasAsterisk ? "*" : ""}
      </label>
      {error && <span className="error-text">{error.message}</span>}
    </div>
  );
};

export default InputTextarea;
